import React, { useState, useEffect } from "react";
import Owl from "../Utils/owl/Owl";
import Gv from "./Gv";

export default function Contact() {
  return (
    <div>
      <div className="in-content-slider">
        <Owl images="slider_contact" />
      </div>
      <Gv gvid="contact_0" />
    </div>
  );
}
